import { GlobalCpmFixedData } from './types';

const globalCpmWebComponentName = 'global-cpm';
const globalCpmToken = 'global-cpm-token';
const globalCpmUsername = 'global-cpm-username';
const globalCpmFullName = 'global-cpm-full-name';
const globalCpmAccountMenu = 'global-cpm-account-menu';
const globalCpmLocaleSelector = 'global-cpm-locale-selector';
const globalCpmCurrentLanguage = 'global-cpm-current-language';
const globalCpmNamesChangeEvent = 'global-cpm-change-names-event';
const globalCpmChangeLanguageEvent = 'global-cpm-change-language-event';
const globalCpmChangeLocaleSelectorEvent = 'global-cpm-change-locale-selector-event';
const globalCpmChangeAccountMenuEvent = 'global-cpm-change-account-menu-event';
const globalCpmCloseLocaleSelectorEvent = 'global-cpm-close-locale-selector-event';
const globalCpmClosePrivacyKey = 'close-privacy-banner';

const ignoreTransformHref = true;

const globalCpmFixedData: GlobalCpmFixedData = {
  links: {
    // TODO: get these items from API
    links: [],
  },
  languageIcon: {
    url: '',
    icon: {
      iconPath: `#arjo-eshop-globe`,
      ignoreTransformHref,
    },
  },
  favoriteIcon: {
    url: '',
    icon: {
      iconPath: `#arjo-eshop-favourite`,
      ignoreTransformHref,
    },
  },
  avatarIcon: {
    url: '',
    icon: {
      iconPath: `#arjo-eshop-avatar`,
      ignoreTransformHref,
    },
  },
  logoutIcon: {
    url: '',
    icon: {
      iconPath: `#arjo-eshop-logout`,
      ignoreTransformHref,
    },
  },
  arrowDownIconPath: `#arjo-ico-down-arrow`,
  tickIconPath: `#arjo-eshop-tick`,
  localeSelectorData: {
    closeButton: {
      iconPath: '#arjo-ico-btn-close',
      ignoreTransformHref,
    },
    globeIcon: {
      iconPath: '#arjo-ico-earth',
      ignoreTransformHref,
    },
  },
  favoriteTooltip: {
    icon: {
      iconPath: '#arjo-eshop-favourite',
      ignoreTransformHref,
    },
    externalResourceScriptPath: 'true',
    externalResourceStylePath: 'true',
    okButton: {
      styleModifier: ['btn'],
      text: '',
    },
  },
};


export {
  globalCpmWebComponentName,
  globalCpmFixedData,
  globalCpmUsername,
  globalCpmToken,
  globalCpmAccountMenu,
  globalCpmCurrentLanguage,
  globalCpmLocaleSelector,
  globalCpmChangeLanguageEvent,
  globalCpmNamesChangeEvent,
  globalCpmChangeLocaleSelectorEvent,
  globalCpmChangeAccountMenuEvent,
  globalCpmCloseLocaleSelectorEvent,
  globalCpmClosePrivacyKey,
  globalCpmFullName,
};
